var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('globalLayout'),_c('checkAcces',{attrs:{"pageAccess":"ecran"}}),_c('div',{staticClass:"globalContent"},[_c('CasTable',{attrs:{"global":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }